export * from './page.component';
